import React, { useState, useEffect } from 'react';

import animPage from 'assets/anim/anim-pageload.json';

import Lottie from 'lottie-react';

import ServiceORG from 'services/serviceOrg';

import PanelDev from 'panels/dev/PanelDev';

import PaneOutlet from '../panes/PaneOutlet';
import PaneSubs from '../panes/PaneSubs';
import PaneTrns from '../panes/PaneTrns';

export default function SubPanelOrgInfo(props) {

    const [doc, setDoc] = useState({});
    const [subData, setSubData] = useState({});

    const [tab, setTab] = useState('outlets');

    const [loading, setLoading] = useState(true);

    const orgService = new ServiceORG();

    const loadData = () => {
        setLoading(true);
        (async function () {
            setTab('outlets');
            var res = await orgService.getOrgById({ 'ordid': props.cid }, '');
            setDoc(res.data);

            res = await orgService.getSubLicById({ 'ordid': res.data.id }, props.cid);
            setSubData(res.data);
            setLoading(false);
        })();
    }

    useEffect(() => {
        loadData();
    }, [props.cid]);

    return (
        <div>
            {
                loading && <div className='flex items-center justify-center w-full h-screen'>
                    <Lottie animationData={animPage} className="w-40 h-40" loop={true} />
                </div>
            }
            {
                !loading && <div>
                    <div className='h-[320px] bg-red-50 px-4 relative'>
                        <div className='h-[220px] bg-prime rounded-b-md'></div>
                        <div className='w-[180px] h-[180px] bg-white border-[6px] border-red-50 rounded-full absolute top-[120px] ml-8'>
                            <img src={doc.profile_media.fileurl} alt='Profile Pic' className='w-full h-full rounded-full' />
                        </div>
                        <h1 className='ml-[220px] text-4xl font-medium absolute'>{doc.name}</h1>
                    </div>
                    <div className='bg-gray-50 px-12 py-4'>
                        <div className='bg-white w-full shadow rounded-md p-4 flex'>
                            <div className='w-[30%]'>
                                <h2 className='text-xl font-medium'>About</h2>
                                <ul className='mt-2'>
                                    <li className='text-sm font-medium py-1 px-2 rounded-md text-red-600 bg-red-50 hover:bg-red-50'>Personal Information</li>
                                </ul>
                            </div>
                            <div className='w-[1px] bg-gray-200 mx-2'></div>
                            <div className='flex-grow'>
                                <div className='p-2'>
                                    <div className="text-slate-400 text-xs font-normal">Email Address</div>
                                    <div className="text-slate-950 text-sm font-medium">{doc.email}</div>
                                </div>
                                <div className='p-2'>
                                    <div className="text-slate-400 text-xs font-normal">Phone Number</div>
                                    <div className="text-slate-950 text-sm font-medium">{`+91 ${doc.phone}`}</div>
                                </div>
                                <div className='p-2'>
                                    <div className="text-slate-400 text-xs font-normal">Physical Address</div>
                                    <div className="text-slate-950 text-sm font-medium">{doc.addresses.length === 0 ? '-' : `${doc.addresses[0].street_1}, ${doc.addresses[0].street_2} ${doc.addresses[0].city}, ${doc.addresses[0].state}, ${doc.addresses[0].country} - ${doc.addresses[0].postal_code}`}</div>
                                </div>
                            </div>
                        </div>
                        <div className='bg-white w-full shadow rounded-md p-4 mt-4'>
                            <h2 className='text-xl font-medium'>Reports</h2>
                            <div class="w-full mt-2">
                                <div className="py-2 mt-2">
                                    <ul className="intro-y flex text-sm font-sans text-gray-600 border-b">
                                        <li className="mx-2"><button className={`py-2 px-2 ${tab === 'outlets' ? 'text-blue-600 font-semibold border-b-2 border-blue-600 hover:text-blue-500' : 'bg-white hover:bg-blue-100 rounded-md'}`} onClick={() => { setTab('outlets') }}>Outlets Report</button></li>
                                        <li className="mx-2"><button className={`py-2 px-2 ${tab === 'subscriptions' ? 'text-blue-600 font-semibold border-b-2 border-blue-600 hover:text-blue-500' : 'bg-white hover:bg-blue-100 rounded-md'}`} onClick={() => { setTab('subscriptions') }}>subscriptions Report</button></li>
                                        <li className="mx-2"><button className={`py-2 px-2 ${tab === 'transactions' ? 'text-blue-600 font-semibold border-b-2 border-blue-600 hover:text-blue-500' : 'bg-white hover:bg-blue-100 rounded-md'}`} onClick={() => { setTab('transactions') }}>Transactions Report</button></li>
                                    </ul>
                                </div>
                            </div>
                            {
                                (() => {
                                    switch (tab) {
                                        case 'outlets':
                                            return (<PaneOutlet org={doc} data={subData} refresh={loadData} />);
                                        case 'subscriptions':
                                            return (<PaneSubs org={doc._id} />);
                                        case 'transactions':
                                            return (<PaneTrns org={doc._id} />);
                                        default:
                                            return (<PanelDev />);
                                    }
                                })()
                            }
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}
